import React from "react";
// import loading from "./"
export const Loading = () => {
    return (

    <div style={{width:"100%",height:"0",paddingBottom:"80%",position:"relative", margin:"auto", PaddingTop:"250px",backgroundColor:"black"}}>
    <img src="/loading_symbol.gif" Width="80px" style={{position:"absolute",margin:"auto", left:"45%", top:"10%"}}/>
    </div>

    )
}